"use client";

import PropTypes from "prop-types";
import Script from "next/script";

import GPTCriteoScript from "components/google-publisher-tags/gpt-criteo-script";
import { adsByPage } from "components/google-publisher-tags/ad-units";

const GPTSlot = (adData) => `
  googletag.defineSlot('${adData?.label}', ${adData?.sizes}, '${adData?.id}').addService(googletag.pubads());`;

const GPTOopSlot = (slot) =>
  `googletag.defineOutOfPageSlot('${slot.label}', '${slot.id}').addService(googletag.pubads())`;

const GPTDisplayOnLoad = ({ adData }) => `
  if (typeof event !== 'undefined' && ${!adData?.lazy} && event.slot.getSlotElementId() == '${
  adData?.id
}' && !event.isEmpty) {
    document.getElementById('${adData?.id}').style.display = 'block';
  }
`;

const getArrayValue = (values) => {
  const valuesToString = values.join('","');
  return values.length > 0 ? `["${valuesToString}"]` : '""';
};

const getTargetings = (targetingParam) => {
  const param = targetingParam.values || targetingParam.value;
  const isArrayValue = Array.isArray(param);
  const value = isArrayValue ? getArrayValue(param) : `"${param}"`;
  return `.setTargeting("${targetingParam.label}",${value})`;
};

const getPubAds = (adData, url, targetingValueList) => `
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  googletag.cmd.push(function() {
    ${adData
      ?.filter((x) => !x.lazy)
      .map((ad) =>
        ad.label.includes("ej_w_oop")
          ? (url?.includes("/projeler") || url?.includes("/satilik-konut")) && GPTOopSlot(ad)
          : GPTSlot(ad)
      )
      .join("")}
    
    ${
      targetingValueList &&
      targetingValueList.length > 0 &&
      `googletag.pubads()${targetingValueList.map((target) => getTargetings(target)).join("")};`
    }
    
    googletag.pubads().enableLazyLoad({ fetchMarginPercent: 100, renderMarginPercent: 1, mobileScaling: 1.0 });
    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs(true);
    googletag.pubads().enableVideoAds();
    setTimeout(() => {
      googletag.pubads().refresh();
    }, 0);
    setInterval(() => {
      googletag.pubads().refresh();
    }, 30000);
    googletag.companionAds().setRefreshUnfilledSlots(true);
    googletag.enableServices();
    
    googletag.pubads().addEventListener('slotRenderEnded', function(event) {
      ${adData
        ?.filter((x) => !x.lazy)
        .map((ad) => !ad.label.includes("ej_w_oop") && GPTDisplayOnLoad({ adData: ad }))
        .join("")}
    });
  });
`;

const GPTHeader = ({ pageName, targetingValueList, path }) => {
  const adData = adsByPage[pageName] || [];

  return (
    <>
      <GPTCriteoScript />
      <Script
        id="gpt-pub-ads"
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: getPubAds(adData, path, targetingValueList) }}
        strategy="afterInteractive"
      />
    </>
  );
};

GPTHeader.propTypes = {
  pageName: PropTypes.string,
  targetingValueList: PropTypes.array,
  path: PropTypes.string,
};

export default GPTHeader;
